import React, { useEffect, useState } from "react";
import "./Clients.css";
import Conect from "../../services/api/Conect";

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [filter, setFilter] = useState("");
  const [newClient, setNewClient] = useState({
    name: "",
    nick_name: "",
    email: "",
    phone: "",
    phone_whatss: false,
    phone_1: "",
    cpf: "",
  });

  useEffect(() => {
    fetchCostumers();
  }, []);

  const fetchCostumers = async () => {
    const token = localStorage.getItem("fptoken");

    try {
      const response = await Conect.get(`/listallcostumers${token}`);
      if (!response.data.erro) {
        setClients(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewClient({
      ...newClient,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddClient = async () => {
    const token = localStorage.getItem("fptoken");
    try {
      let response;
      if (editingClient) {
        response = await Conect.put(`/editcostumer${editingClient.id}`, newClient);
      } else {
        response = await Conect.post(`/createcostumer${token}`, newClient);
      }

      if (!response.data.erro) {
        fetchCostumers();
        setNewClient({
          name: "",
          nick_name: "",
          email: "",
          phone: "",
          phone_whatss: false,
          phone_1: "",
          cpf: "",
        });
        setEditingClient(null);
        setIsModalOpen(false);
      }

    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditClient = (client) => {
    setNewClient(client);
    setEditingClient(client);
    setIsModalOpen(true);
  };

  const filteredClients = clients.filter((c) =>
    [c.name, c.nick_name, c.cpf].some((field) =>
      field?.toLowerCase().includes(filter.toLowerCase())
    )
  );

  return (
    <div className="cli-container">
      <div className="cli-header">
        <h2>Clientes Cadastrados</h2>

        <div className="cli-actions-header">
          <input
            type="text"
            className="cli-filter"
            placeholder="Buscar por nome, fantasia ou CPF"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />

          <button
            className="cli-add-btn"
            onClick={() => setIsModalOpen(true)}
          >
            + Novo Cliente
          </button>
        </div>
      </div>

      <div className="cli-table-container">
        <table className="cli-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Nome</th>
              <th>Fantasia</th>
              <th>Email</th>
              <th>Telefone</th>
              <th>WhatsApp</th>
              <th>Telefone 2</th>
              <th>CPF</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody>
            {filteredClients.length > 0 ? (
              filteredClients.map((client, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{client.name}</td>
                  <td>{client.nick_name}</td>
                  <td>{client.email || "Não informado"}</td>
                  <td>{client.phone}</td>
                  <td>{client.phone_whatss ? "✅" : "❌"}</td>
                  <td>{client.phone_1 || "-"}</td>
                  <td>{client.cpf || "-"}</td>

                  <td>
                    <button
                      className="cli-edit-btn"
                      onClick={() => handleEditClient(client)}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  Nenhum cliente encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="cli-modal-overlay">
          <div className="cli-modal">

            <form className="cli-form">
              <h3>
                {editingClient
                  ? "Editar Cliente"
                  : "Novo Cliente"}
              </h3>

              <div className="cli-form-row">
                <input
                  name="name"
                  value={newClient.name}
                  onChange={handleChange}
                  placeholder="Nome completo"
                />

                <input
                  name="nick_name"
                  value={newClient.nick_name}
                  onChange={handleChange}
                  placeholder="Nome fantasia"
                />
              </div>

              <div className="cli-form-row">
                <input
                  name="email"
                  value={newClient.email}
                  onChange={handleChange}
                  placeholder="Email"
                />

                <input
                  name="cpf"
                  value={newClient.cpf}
                  onChange={handleChange}
                  placeholder="CPF"
                />
              </div>

              <div className="cli-form-row">
                <input
                  name="phone"
                  value={newClient.phone}
                  onChange={handleChange}
                  placeholder="Telefone"
                />

                <input
                  name="phone_1"
                  value={newClient.phone_1}
                  onChange={handleChange}
                  placeholder="Telefone alternativo"
                />
              </div>

              <label className="cli-checkbox">
                <input
                  type="checkbox"
                  name="phone_whatss"
                  checked={newClient.phone_whatss}
                  onChange={handleChange}
                />
                Tem WhatsApp?
              </label>

              <div className="cli-modal-actions">
                <button
                  type="button"
                  className="cli-cancel-btn"
                  onClick={() => {
                    setIsModalOpen(false);
                    setEditingClient(null);
                  }}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  onClick={handleAddClient}
                  className="cli-save-btn"
                >
                  Salvar
                </button>
              </div>
            </form>

          </div>
        </div>
      )}
    </div>
  );
};

export default Clients;
